import { createApp } from 'vue/dist/vue.esm-bundler';

import agendaApp from './vue/agenda';
import concertGuideApp from './vue/concertGuide';
import loginApp from './vue/login';
import userStateApp from './vue/userState';
import passwordApp from './vue/changePassword';
import accountApp from './vue/account';
import catalogApp from './vue/catalog';
import addPurchaseApp from './vue/purchase';
import catalogDetailApp from './vue/catalogDetail';
import discountApp from './vue/discount';
import subscriptionsApp from './vue/subscriptions';

const clickOutside = {
	beforeMount: (el, binding) => {
		el.clickOutsideEvent = event => {
			if (!(el == event.target || el.contains(event.target))) {
				binding.value();
			}
		};
		document.addEventListener('click', el.clickOutsideEvent);
	},
	unmounted: el => {
		document.removeEventListener('click', el.clickOutsideEvent);
	},
};

document.addEventListener('DOMContentLoaded', () => {
	const agendaContainer = document.getElementById('agenda');
	const agendaWidgetContainers = document.querySelectorAll('.agenda-widget');
	const concertGuideContainer = document.getElementById('concertguide');
	const loginContainer = document.getElementById('login');
	const userState = document.getElementById('userState');
	const passwordContainer = document.getElementById('passwordChange');
	const account = document.getElementById('myAccount');
	const catalogContainer = document.getElementById('catalog');
	const catalogContainers = document.querySelectorAll('.catalog');
	const catalogDetailContainer = document.getElementById('catalogDetail');
	const addPurchaseContainer = document.getElementById('addPurchase');
	const discountContainer = document.getElementById('discountCheck');
	const subscriptionContainers = document.querySelectorAll('.subscriptions');

	if (agendaContainer) {
		createApp(agendaApp).directive('clickOutside', clickOutside).mount(agendaContainer);
	}

	agendaWidgetContainers.forEach((container) => {
		createApp(agendaApp).mount(container);
	});

	if (concertGuideContainer) {
		createApp(concertGuideApp).mount(concertGuideContainer);
	}

	if (loginContainer) {
		createApp(loginApp).mount(loginContainer);
	}

	if (userState) {
		createApp(userStateApp).mount(userState);
	}

	if (passwordContainer) {
		createApp(passwordApp).mount(passwordContainer);
	}

	if (account) {
		createApp(accountApp).mount(account);
	}

	if (catalogDetailContainer) {
		createApp(catalogDetailApp).mount(catalogDetailContainer);
	}

	if (addPurchaseContainer) {
		createApp(addPurchaseApp).mount(addPurchaseContainer);
	}

	if (catalogContainer) {
		createApp(catalogApp).mount(catalogContainer);
	}

	catalogContainers.forEach(container => {
		createApp(catalogApp).mount(container);
	});

	if (discountContainer) {
        createApp(discountApp).mount(discountContainer);
	}

	subscriptionContainers.forEach(container => {
		createApp(subscriptionsApp).mount(container);
	});
});
